import { Component, Output, EventEmitter, Input } from '@angular/core';
import { SelectCardService } from 'src/app/services/select-card.service';
import { Tasks } from 'src/app/models/common/tasks.model';

@Component({
    selector: 'app-actions-bar',
    templateUrl: './actions-bar.component.html',
    styleUrls: ['./actions-bar.component.scss'],
    standalone: false
})
export class ActionsBarComponent {
  /**
   * Array de opciones a mostrar en la barra
   * Objetos con propiedades de Key, Name
   */
  @Input() tasks: Tasks[];
  @Input() forceShowButtons = false;
  @Input() titleForceShowButtons: string;
  @Input() key: string = 'Id';
  @Input() modalState: number = 2;
  @Input() items;
  @Input() massiveAct: boolean = false;
  /**
   * Emite la Key de la opción seleccionada
   */
  @Output() selectedOptions: EventEmitter<any> = new EventEmitter();
  @Output() optionSelectedFromSelector: EventEmitter<any> = new EventEmitter();

  constructor(
    public selectCardService: SelectCardService
  ) { }

  onSelectedOptions(task: string) {
    this.selectedOptions.emit(task);
  }

  /**
   * Method only for interaction with generic selector
   * @param event Event type id and name or text, called from generic selector
   */
  onOptionSelected(event: any) {
    this.optionSelectedFromSelector.emit({ id: event.id, name: event.text });
  }

}
